/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: contacts-edit-view-component.ts
 *
 * Created by randysorensen on 5/4/18.
 */

function ContactsEditViewController(
    this: JS5Object,
    _: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    ContactsService: JS5Object,
    SidebarService: JS5Object,
) {

    const getData = () => {
        this.loadingIndicator.show = true;
        return ContactsService.getContactEditData()
            .then((contact: JS5Object) => {
                this.contact = contact;
            })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    const requiredFieldsArePopulated = () => {
        const emailAddress = _.get(this, 'contact.emailAddress.length') > 0;
        return emailAddress;
    };

    const saveContact = () => {
        this.loadingIndicator.show = true;
        ContactsService.saveEditData()
            .then((savedContact: JS5Object) => {
                this.contact = savedContact;
            })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    const revertContact = () => {
        this.contact = ContactsService.revertEditData();
    };

    const initToolbar = () => {
        this.toolbarButtonDefs = [
            {
                label: 'Save',
                enabled: () => this.editorForm.$dirty && requiredFieldsArePopulated(),
                onClick: saveContact
            },
            {
                label: 'Revert',
                enabled: () => this.editorForm.$dirty,
                onClick: revertContact
            },
            {
                label: 'Close',
                enabled: () => true,
                onClick: () => ContactsService.exitEdit()
            }];
    };

    this.$onInit = () => {
        this.contact = {};

        this.breadcrumbName = '';
        this.toolbarButtonDefs = undefined;

        BreadcrumbService.editService = ContactsService;
        SidebarService.editService = ContactsService;

        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        initToolbar();

        getData();
    };

    this.$postLink = () => {
        $timeout(() => {
            ContactsService.editorForm = this.editorForm;
        });
    };

    this.getBreadcrumbName = () => {
        const firstName = _.get(ContactsService, 'originalContact.firstName');
        const lastName = _.get(ContactsService, 'originalContact.lastName');

        let breadcrumbName = lastName;
        if (lastName && firstName) {
            breadcrumbName += ', ';
        }
        breadcrumbName += firstName;

        return (breadcrumbName || '<New Contact>');
    };

}

angular.module('prism-ui.system').component(
    'contactsEditView', {
        controller: ContactsEditViewController,
        templateUrl: 'system/contacts/editView/contacts-edit-view-template.html',
        bindings: {}
    });
